import http from './http'

export default {
  getPrizes: eventId => http.get(`/v2/events/${eventId}/prizes`),
  setCutoutWinner: (eventId, drawId) => http.post(`/v2/events/${eventId}/draws/${drawId}/cutout-winner`, {}, { silent: true }),
  getFinalPdf: eventId => http.get(`/v2/events/${eventId}/prizes/final-round-pdf`, { responseType: 'blob' })
}



// WEBPACK FOOTER //
// ./src/services/api/prizes.js